import React, { useState, useEffect } from "react";
import DataTable, { Columns, Rows, Pagination } from "react-data-table-component";
import { Checkbox } from "@mui/material";
import './Table2.css'

function Table2({ sidebarOpen, col, roo, showCheckbox }) {

  const handleEditClick = (row) => {
    console.log("Clicked row:", row);
  };

  const handleSelectedRowsChange = () => {
    console.log("nour")
  }

  const customStyles = {
    table: {
      style: {
        backgroundColor: `var(--light)`
      }
    },
    rows: {
      style: {
        backgroundColor: `white`,
        color: `var(--title-color)`,
        marginTop: "10px",
        marginBottom: "10px"
      }
    },
    headCells: {
      style: {
        backgroundColor: `white`,
        color: "#1B262C",
        fontSize: "14px"
      }
    },
    pagination: {
      style: {
        backgroundColor: `white`,
        color: `var(--title-color)`,
        borderTop: "1px solid white"
      }
    },
  };

  const NoDataComponent = () => (
    <div style={{ color: `var(--title-color)`, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px', width: '100%', backgroundColor: `var(--light)`, padding: "10px" }}>There are no records to display</div>
  );

  return (
    <div style={{ height: "550px", backgroundColor: `white` }} >
      <DataTable
        columns={col}
        data={roo}
        pagination
        onSelectedRowsChange={handleSelectedRowsChange}
        customStyles={customStyles}
        noDataComponent={<NoDataComponent />}
        className="custom-table"
        noHeader
      />
    </div>
  );
}

export default Table2;